import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { bootstrapContractorCapability } from './capability';
import { loadWebRuntimeConfig } from './config/app-config';
import { Portal } from './portal';
import './styles.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found');
}

bootstrapContractorCapability();
const config = loadWebRuntimeConfig();

createRoot(rootElement).render(
  <StrictMode>
    <Portal apiBaseUrl={config.apiBaseUrl} />
  </StrictMode>,
);
